import { useSelector } from "react-redux";
import ITrackOpticsPageState from "interfaces/TrackOpticsPageState";
import DateRange, { DateRangeType } from "interfaces/DateRange";
import { parseISO } from "date-fns";

interface IExtendedTrackOpticsStore extends ITrackOpticsPageState {
  convertedToDateSelectedDateRange: DateRange;
}

export const useTrackOpticsStore = (): IExtendedTrackOpticsStore => {
  const { selectedFacility, selectedDateRange } = useSelector(
    (state: { trackOpticsPage: ITrackOpticsPageState }) =>
      state?.trackOpticsPage
  );
  const convertedToDateSelectedDateRange = useSelector(
    (state: { trackOpticsPage: ITrackOpticsPageState }) => {
      if (state?.trackOpticsPage?.selectedDateRange) {
        const range: DateRange = {
          Type: state.trackOpticsPage.selectedDateRange.Type
        };
        if (
          state?.trackOpticsPage?.selectedDateRange?.Type ===
          DateRangeType.Custom
        ) {
          range.CustomDateRange =
            state.trackOpticsPage.selectedDateRange.CustomDateRange.map(s =>
              parseISO(s)
            );
        }
        return range;
      }
      return {
        Type: DateRangeType.Today
      };
    }
  );

  return {
    selectedFacility,
    selectedDateRange,
    convertedToDateSelectedDateRange
  };
};
